import { CommentsoldIntegrationProduct } from "@redotech/redo-integrations-definitions-common/commentsold";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const deleteCommentsoldIntegration = {
  name: "deleteCommentsoldIntegration" as const,
  input: z.object({ product: createEnum(CommentsoldIntegrationProduct) }),
  output: z.void(),
};
